module.exports = __webpack_public_path__ + "62a77a6a83d7a22859ee5add4d888c7b.mp4";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/spacemarines-preview.mp4
// module id = 647
// module chunks = 0